import { useCallback } from "react";
import logo from "../assets/images/weviira.png";

const usePrintInvoicesSingle = () => {
  const printRepInvoicesSingle = useCallback((data) => {
    try {
      const invoicesHTML = data
        .map(
          (item) => `
    <div class="invoice">

      <div class="row">
        <div class="client-info">
          <p><strong>الكود:</strong> ${item.invoiceCode || "N/A"}</p>
          <p><strong>اسم العميل:</strong> ${item.customer || "N/A"}</p>
          <p><strong>العنوان:</strong> ${item.address || "N/A"}</p>
          <p><strong>الهاتف:</strong> ${item.phone || "N/A"}</p>
          <p><strong>المحافظة:</strong> ${
            item.governorate?.name || "N/A"
          }</p>
          <p><strong>الملاحظات:</strong> ${item.note || "N/A"}</p>
            <p><strong>الرقم الثاني:</strong> ${item?.socendPhone || "N/A"}</p>
        </div>
        <div class="client-info">
          <p><strong>تاريخ الفاتورة:</strong> ${
            new Date(item.invoiceDate).toLocaleDateString("ar-EG") || "N/A"
          }</p>
          <p><strong>السكرتير:</strong> ${item.userName || "N/A"}</p>
          <p><strong>الهاتف:</strong> ${item.phone || "N/A"}</p>
          <p><strong>المندوب:</strong> ${
            item.representative?.fullName || "N/A"
          }</p> 
          <p><strong>الصفحه:</strong> ${
            item.page || "N/A"
          }</p>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>الصنف</th>
            <th>الكمية</th>
            <th>السعر</th>
            <th>الإجمالي</th>
          </tr>
        </thead>
        <tbody>
          ${(item.invoiceCategories || [])
            .map(
              (category) => `
            <tr>
              <td>${category.category?.name || "N/A"}</td>
              <td>${category.quantity || 0}</td>
              <td>${category.price || 0}</td>
              <td>${category.total || 0}</td>
            </tr>`
            )
            .join("")}
        </tbody>
      </table>

      <table class="summary">
        <tbody>
          <tr><td>الاجمالي</td><td>${item.totalPrice - item.shipping}</td></tr>
          <tr><td>الشحن</td><td>${item.shipping || 0}</td></tr>
          <tr class="total"><td>الاجمالي مع الشحن</td><td>${
            item.totalPrice
          }</td></tr>
        </tbody>
      </table>
    </div>`
        )
        .join("");

      const invoicePage = `
      <html>
        <head>
          <title>فواتير</title>
          <style>
        body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 5px;
flex-direction: column; 
display: flex; 
justify-content:end; 
align-items: end;
  color: #333;
  font-weight: bold;
}

.invoice {
  padding: 5px;
  border-radius: 5px;
  overflow: hidden;
  page-break-after: always;
  width: 100mm; /* Adjust for better fit */
  max-width: 100%;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}

.logo {
  width: 35px;
  height: auto;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 5px;
}

.client-info {
  flex: 1;
  padding: 5px;
  font-size: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: #fff;
}

th, td {
  border: 1px solid black;
  padding: 3px;
  font-size: 12px;
  text-align: center;
}

th {
  background: #f1f1f1;
}

.summary {
  width: 100%;
  margin-top: 5px;
  border-collapse: collapse;
  background: #f9f9f9;
}

.summary td {
  padding: 5px;
  border: 1px solid #000;
  font-size: 12px;
  font-weight: 900;
  text-align: center;
}

@media print {
  body {
    margin: 0;
    padding: 0;
    background: #fff;
  }



  table {
    font-size: 10px;
  }

  th, td {
    padding: 2px;
  }

  .summary {
    width: 100%;
    margin: 0;
  }

  .page-break {
    page-break-before: avoid;
    page-break-after: avoid;
    page-break-inside: avoid;
  }
}

          </style>
        </head>
        <body>
          ${invoicesHTML}
        </body>
      </html>`;

      const invoiceWindow = window.open("", "invoicesPage");
      invoiceWindow.document.write(invoicePage);
      invoiceWindow.document.close();
      invoiceWindow.print();
    } catch (error) {
      console.error("Error printing invoices:", error);
    }
  }, []);

  return printRepInvoicesSingle;
};

export default usePrintInvoicesSingle;
